import Editor from './editor';

const doc = {
  Editor,
};
export default doc;
